<template>
    <div>
        <main class="main" :class="{'main--collapsed': leftCollapsed}">
            <aside class="aside">
                <div class="aside__inner">
                    <header class="aside__header"> Filters
                        <a class="aside__collapse" @click="leftCollapsed = !leftCollapsed"></a>
                    </header>
                    
                    <ul class="filters__list">
                        <li v-if="false">
                            <a class="filters__list__title" v-b-toggle.company-type>
                                Company Type
                                <span class="hint" title="The text for the hint">i</span>
                            </a>
                            
                            <b-collapse class="filters__list__content" id="company-type">
                                <ul class="list-input">
                                    <li class="input-radio mb-2">
                                        <input id="rfilter-fundingSeries-Angel" type="radio" name="qwe" value="[object Object]">
                                        <label for="rfilter-fundingSeries-Angel">Startups</label>
                                    </li>
                                    <li class="input-radio mb-2">
                                        <input id="r2filter-fundingSeries-Angel" type="radio" name="qwe" value="[object Object]">
                                        <label for="r2filter-fundingSeries-Angel">Ecosystems</label>
                                    </li>
                                </ul>
                            </b-collapse>
                        </li>
                        <li>
                            <a class="filters__list__title" v-b-toggle.activity-type>Activity Type</a>

                            <b-collapse class="filters__list__content" id="activity-type">
                                <ul class="filters__list__choose">
                                    <li class="input-checkbox mr-1">
                                        <input id="filter-activityType-all" type="checkbox" v-model="showAll">
                                        <label for="filter-activityType-all">All</label>
                                    </li>
                                    <li class="input-checkbox mr-1">
                                        <input id="filter-activityType-notes" type="checkbox" v-model="filter.activityType.notes">
                                        <label for="filter-activityType-notes">Notes</label>
                                    </li>
                                    <li class="input-checkbox mr-1">
                                        <input id="filter-activityType-contacts" type="checkbox" v-model="filter.activityType.contacts">
                                        <label for="filter-activityType-contacts">Contacts</label>
                                    </li>
                                    <li class="input-checkbox mr-1">
                                        <input id="filter-activityType-files" type="checkbox" v-model="filter.activityType.files">
                                        <label for="filter-activityType-files">Files</label>
                                    </li>
                                    <li class="input-checkbox mr-1">
                                        <input id="filter-activityType-interactions" type="checkbox" v-model="filter.activityType.interactions">
                                        <label for="filter-activityType-interactions">Interactions</label>
                                    </li>
                                </ul>
                            </b-collapse>
                        </li>
                        <li>
                            <a class="filters__list__title" v-b-toggle.period>Filter By Date</a>

                            <b-collapse class="filters__list__content" id="period">
                                <date-picker v-model="period" range></date-picker>
                            </b-collapse>
                        </li>
                    </ul>
                </div>
            </aside>
            <div class="content">
                <header class="content__header">
                    <h1 class="heading1">Feed</h1>
                    <a v-if="false" href="#" class="link-settings">Admin Settings</a>
                </header>

                <div v-for="(typeLogs, typeIndex) in logs" :key="typeIndex">
                    <template v-if="typeLogs.logs.length">
                        <div class="content__inner-section">
                            <div class="content__topbar" v-if="typeof types[typeLogs.type] !== 'undefined'">{{types[typeLogs.type]}}</div>
                            <div class="content__topbar" v-else>{{typeLogs.type}}</div>

                            <ul class="action-logs-list">
                                <li v-for="(log, logIndex) in typeLogs.logs" :key="logIndex">
                                    <Avatar
                                        :username="log.user_name"
                                        :src="log.user_avatar"
                                        :size="44">
                                    </Avatar>

                                    <div class="action-logs-list__inner">
                                        <span class="action-logs-list__user" :class="{deleted: log.user_deleted}">{{log.user_name}}</span>

                                        <small>{{log.operation}}</small>

                                        <span class="action-logs-list__operation" v-if="typeof log.tag !== 'undefined'">
                                            <a :href="'/startups?tag=' + log.tag.name" target="_blank">{{log.tag.name}}</a>
                                        </span>

                                        <span class="action-logs-list__operation" v-if="typeof log.startup !== 'undefined'">
                                            <div class="image-block">
                                                <img :src="LogoHelper.getLogo(log.startup.logo)">
                                            </div>
                                            <a :href="'/startups/' + log.startup.id" target="_blank">{{log.startup.name}}</a>
                                        </span>

                                        <span class="action-logs-list__operation" v-if="typeof log.ecosystem !== 'undefined'">
                                            <div class="image-block">
                                                <img :src="LogoHelper.getLogo(log.ecosystem.logo)">
                                            </div>
                                            <a :href="'/startups/' + log.ecosystem.id" target="_blank">{{log.ecosystem.name}}</a>
                                        </span>

                                        <small v-if="typeof log.between !== 'undefined'">
                                            {{log.between}}
                                        </small>

                                        <span class="mr-2" v-if="typeof log.tracker !== 'undefined'">
                                            <a class="action-logs-list__tracker-button" :href="'/trackers/' + log.tracker.id" target="_blank">{{log.tracker.name}}</a>
                                        </span>

                                        <small v-if="typeof log.between2 !== 'undefined'">
                                            {{log.between2}}
                                        </small>

                                        <time v-if="typeof types[typeLogs.type] !== 'undefined'" class="action-logs-list__date">{{log.time}}</time>

                                        <div v-if="typeof log.folder !== 'undefined'">
                                            <a class="action-logs-list__tracker-folder" :href="'/trackers/folder/' + log.folder.id" target="_blank">{{log.folder.name}}</a>
                                        </div>
                                        
                                        <template v-if="typeof log.users !== 'undefined'">
                                            <div class="action-logs-list__user-wrapper">
                                                <div class="action-logs-list__user-inner" v-for="(item, index) in log.users" :key="index">
                                                    <Avatar
                                                        :username="item.name"
                                                        :src="item.avatar"
                                                        :size="40">
                                                    </Avatar>
                                                    {{item.name}} <template v-if="item.post">| {{item.post}}</template>
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.startups !== 'undefined'">
                                            <div>
                                                <template v-for="(item, index) in log.startups">
                                                    <div class="action-logs-list__operation" :key="index">
                                                        <div class="image-block">
                                                            <img :src="LogoHelper.getLogo(item.logo)" alt="">
                                                        </div>
                                                        <a :href="'/startups/' + item.id" target="_blank">{{item.name}}</a>
                                                    </div>
                                                </template>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.ecosystems !== 'undefined'">
                                            <div>
                                                <div class="action-logs-list__operation" v-for="(item, index) in log.ecosystems" :key="index">
                                                    <div class="image-block">
                                                        <img :src="LogoHelper.getLogo(item.logo)" alt="">
                                                    </div>
                                                    <a :href="'/ecosystems/' + item.id" target="_blank">{{item.name}}</a>
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.trackers !== 'undefined'">
                                            <div class="action-logs-list__trackers">
                                                <span class="action-logs-list__tracker" v-for="(item, index) in log.trackers" :key="index">
                                                    <a :href="'/trackers/' + item.id" target="_blank">{{item.name}}</a>
                                                </span>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.fields !== 'undefined'">
                                            <div>
                                                <div class="action-logs-list__custom" v-for="(item, index) in log.fields" :key="index">
                                                    {{item.name}}
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.field_value !== 'undefined'">
                                            <div class="action-logs-list__custom line-clamp line-clamp1">
                                                <b>{{log.field_value.name}}</b>
                                                <template v-if="log.field_value.value.length">: {{log.field_value.value}}</template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.note !== 'undefined'">
                                            <div>
                                                <div class="line-clamp line-clamp1 action-logs-list__activity">
                                                    <span :class="getActivityIconClass(log.note.type)"></span>{{log.note.text}}
                                                </div>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.tags !== 'undefined'">
                                            <div class="tags-list tags-list--light">
                                                <div class="tags-list__tag" v-for="(item, index) in log.tags" :key="index">
                                                    <a :href="'/startups?tag=' + item.name" target="_blank">{{item.name}}</a>
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.tasks !== 'undefined'">
                                            <div class="action-logs-list__tasks">
                                                <template v-for="(item, index) in log.tasks">
                                                    <div class="action-logs-list__task" v-if="item.name" :key="index">
                                                        <a :href="'/?open_task=' + item.id" target="_blank">{{item.name}}</a>
                                                    </div>
                                                </template>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>

                                                <div class="action-logs-list__operation" v-if="typeof log.tasks[0].startup !== 'undefined'">
                                                    <div class="image-block">
                                                        <img :src="LogoHelper.getLogo(log.tasks[0].startup.logo)" alt="">
                                                    </div>
                                                    <a :href="'/startups/' + log.tasks[0].startup.id" target="_blank">{{log.tasks[0].startup.name}}</a>
                                                </div>

                                                <span class="action-logs-list__tracker" v-if="typeof log.tasks[0].tracker !== 'undefined'">
                                                    <a :href="'/trackers/' + log.tasks[0].tracker.id" target="_blank">{{log.tasks[0].tracker.name}}</a>
                                                </span>

                                                <template   v-if="typeof log.tasks[0].status !== 'undefined'">
                                                    <span :class="{'action-logs__status—open': log.tasks[0].status == 'Open',
                                                    'action-logs__status—progress': log.tasks[0].status == 'In progress',
                                                    'action-logs__status—blocked': log.tasks[0].status == 'Blocked',
                                                    'action-logs__status—done': log.tasks[0].status == 'Done'}">{{log.tasks[0].status}}</span>
                                                </template>

                                            </div>
                                        </template>

                                        <template v-if="typeof log.contacts !== 'undefined'">
                                            <div>
                                                <div class="action-logs-list__user-inner" v-for="(item, index) in log.contacts" :key="index">
                                                    <Avatar
                                                        :username="item.name"
                                                        :src="item.avatar"
                                                        :size="40">
                                                    </Avatar>
                                                    {{item.details}}
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.files !== 'undefined'">
                                            <div class="action-logs-list__file-wrapper">
                                                <div class="action-logs-list__file" v-for="(item, index) in log.files" :key="index">
                                                    {{item.name}}
                                                </div>

                                                <template v-if="log.add_count">
                                                    <span class="action-logs-list__more">+ {{log.add_count}} More</span>
                                                </template>
                                            </div>
                                        </template>

                                        <template v-if="typeof log.startup_stage !== 'undefined'">
                                            <div>
                                                <div class="action-logs-list__operation">
                                                    <div class="image-block">
                                                        <img :src="LogoHelper.getLogo(log.startup_stage.startup.logo)" alt="">
                                                    </div>
                                                    <a :href="'/startups/' + log.startup_stage.startup.id" target="_blank">{{log.startup_stage.startup.name}}</a>
                                                </div>
                                                was moved to {{log.startup_stage.stage}}
                                            </div>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>

                <div class="no-results-section" v-if="!hasLogs && loaded">
                    <h3 class="heading3">No Results</h3>

                    <p>Try changing your filters to see activity from users in your company</p>
                </div>

                <div class="action-logs__spinner">
                    <span v-if="loading"><b-spinner class="mr-1" small></b-spinner>Loading...</span>
                    <a v-if="hasMore && !loading" @click="getList">Load More</a>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import actionLogs from "@/services/action-logs.service";
import Avatar from "vue-avatar";
import DatePicker from "vue2-datepicker";

export default {
    components: {
        Avatar,
        DatePicker,
    },

    data() {
        return {
            logs: [],
            types: {
                'today': 'Today',
                'yesterday': 'Yesterday',
                'week': 'Previous 7 Days',
                'month': 'This Month',
            },
            leftCollapsed: false,

            showAll: true,
            watchAll: true,
            filter: {
                activityType: {
                    'notes': false,
                    'contacts': false,
                    'files': false,
                    'interactions': false,
                },

                period: [null, null],
            },

            loaded: false,

            period: [null, null],
            maxCount: 5,
            minDate: 0,
            loading: false,
            hasMore: false,
        }
    },

    mounted() {
        this.getList()
        this.checkScroll()
    },

    watch: {
        filter: {
            deep: true,
            handler() {
                this.logs = []
                this.minDate = 0

                let selectedAll = true

                for (let i in this.filter.activityType) {
                    if (!this.filter.activityType[i]) {
                        selectedAll = false
                        break
                    }
                }

                if (!selectedAll) {
                    this.watchAll = false
                    this.showAll = false
                }

                this.$nextTick(() => {
                    this.getList()
                    this.watchAll = true
                })
            }
        },

        showAll() {
            if (this.watchAll) {
                this.logs = []
                this.minDate = 0
                this.getList()
            }
        },

        period() {
            this.filter.period = [
                this.dateHelper.encodeDateForServer(this.period[0]),
                this.dateHelper.encodeDateForServer(this.period[1]),
            ]
        }
    },

    computed: {
        hasLogs() {
            let hasLogs = false

            for (let i in this.logs) {
                if (this.logs[i].logs.length) {
                    hasLogs = true
                    break
                }
            }

            return hasLogs
        }
    },

    methods: {
        getList() {
            this.loading = true
            let empty = true
            let filter = this.filter
            filter.activityType.all = this.showAll
            this.loaded = false

            actionLogs.getActionLogsFeed(filter, this.minDate).then(response => {
                let logs = response.data.logs
                for (let type in logs) {

                    if (logs[type].length && empty) {
                        empty = false
                    }

                    let index = this.arrayHelper.findIndexByColumnValue(this.logs, 'type', type)
                    if (index < 0) {
                        this.logs.push({
                            type:  type,
                            logs: [],
                        })

                        index = this.arrayHelper.findIndexByColumnValue(this.logs, 'type', type)
                    }

                    this.logs[index].logs = this.logs[index].logs.concat(logs[type])
                }

                this.loading = false
                this.minDate = response.data.min_date

                if (empty) {
                    this.hasMore = false
                }
                else {
                    this.hasMore = true
                }

                this.loaded = true
            })
        },

        getActivityIconClass(type) {
            if (type == 'note') {
                return 'activity-list__title--note'
            }
            else if (type == 'phone_call') {
                return 'activity-list__title--call'
            }
            else if (type == 'email') {
                return 'activity-list__title--email'
            }
            else if (type == 'meeting') {
                return 'activity-list__title--meeting'
            }
            else {
                return ''
            }
        },

        checkScroll () {
            window.onscroll = () => {
                let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

                if (bottomOfWindow && this.hasMore) {
                    this.getList()
                }
            }
        }
    }
}
</script>

<style scoped>

</style>